import { render, staticRenderFns } from "./SlotSuggestion.vue?vue&type=template&id=48df0dea&scoped=true&"
import script from "./SlotSuggestion.vue?vue&type=script&lang=js&"
export * from "./SlotSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./SlotSuggestion.vue?vue&type=style&index=0&id=48df0dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df0dea",
  null
  
)

export default component.exports